import { render } from "./widget-eoru-ge.vue?vue&type=template&id=29bc329a"
import script from "./widget-eoru-ge.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-eoru-ge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/widgets/widget-eoru-ge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29bc329a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29bc329a', __exports__)) {
    api.reload('29bc329a', __exports__)
  }
  
  module.hot.accept("./widget-eoru-ge.vue?vue&type=template&id=29bc329a", () => {
    api.rerender('29bc329a', render)
  })

}


export default __exports__